import axiosClient from './axiosClient';
import { UserAchievement } from '../types'; 

export const addUserAchievementApi = async (uid: string, achievementData: Omit<UserAchievement, "id" | "earnedAt">): Promise<UserAchievement> => {
  const response = await axiosClient.post(`/users/${uid}/achievements`, achievementData);
  return response.data;
};

export const fetchUserAchievementsApi = async (uid: string): Promise<UserAchievement[]> => {
  const response = await axiosClient.get(`/users/${uid}/achievements`);
  return response.data;
};

export const deleteUserAchievementApi = async (uid: string, achievementId: string): Promise<void> => {
  await axiosClient.delete(`/users/${uid}/achievements/${achievementId}`);
};
